import { labelids } from "../../assets/data/TkExplanationProperty";

const manualList = [
  {
    title: "新システムの概要",
    index: labelids.labelid.SCRW020001_02,
    link: "新システムの概要.pdf",
  },
  {
    title: "照会する",
    index: labelids.labelid.SCRW020001_03,
    link: "照会する.pdf",
  },
  {
    title: "申請・届出対応",
    index: labelids.labelid.SCRW020001_04,
    link: "申請・届出対応.pdf",
  },
  {
    title: "代行入力対応",
    index: labelids.labelid.SCRW020001_05,
    link: "代行入力対応.pdf",
  },
  {
    title: "掛金届・掛金納付状況管理",
    index: labelids.labelid.SCRW020001_07,
    link: "掛金届・掛金納付状況管理.pdf",
  },
  {
    title: "退職者状況管理",
    index: labelids.labelid.SCRW020001_08,
    link: "退職者状況管理.pdf",
  },
  {
    title: "収納・納付請求処理",
    index: labelids.labelid.SCRW020001_09,
    detail: labelids.labelid.SCRW020001_10,
    link: "収納・納付請求処理.pdf",
  },
  {
    title: "補助金管理",
    index: labelids.labelid.SCRW020001_11,
    link: "補助金管理.pdf",
  },
  {
    title: "業務状況管理",
    index: labelids.labelid.SCRW020001_12,
    link: "業務状況管理.pdf",
  },
  {
    title: "アカウント管理",
    index: labelids.labelid.SCRW020001_13,
    link: "アカウント管理.pdf",
  },
  {
    title: "コミュニケーション",
    index: labelids.labelid.SCRW020001_14,
    link: "コミュニケーション管理.pdf",
  },
  {
    title: "テンプレート管理",
    index: labelids.labelid.SCRW020001_15,
    detail: labelids.labelid.SCRW020001_16,
    link: "テンプレート管理.pdf",
  },
  {
    title: "機構職員参照用手続きマニュアル",
    index: labelids.labelid.SCRW020001_17,
    detail: labelids.labelid.SCRW020001_18,
    link: "その他の手続き（非公開）（機構職員参照用）.pdf",
  },
];

export { manualList };
